import { CompilerClientError } from "./errors"

export interface CompilerRuntimeConfig {
  templateId: string
}

/**
 * Browser-safe compiler settings. HTTP and WebSocket hosts stay on the server
 * (`COMPILER_API_URL`) and the reverse proxy. This must not read them.
 */
export function getCompilerRuntimeConfig(): CompilerRuntimeConfig {
  const templateId = process.env.NEXT_PUBLIC_TEMPLATE_ID?.trim() || ""

  if (!templateId) {
    throw new CompilerClientError("Missing NEXT_PUBLIC_TEMPLATE_ID", {
      code: "MISSING_TEMPLATE_ID",
    })
  }

  return { templateId }
}
